interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  const getPageNumbers = () => {
    const pages: (number | string)[] = [];
    const maxVisible = 7;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 5; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(totalPages);
      }
    }

    return pages;
  };

  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-center gap-2">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="w-10 h-10 flex items-center justify-center rounded-lg border-2 border-gray-200 text-gray-600 hover:border-[#D4AF37] hover:text-[#D4AF37] disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer transition-all"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>

      {getPageNumbers().map((page, index) => (
        <div key={index}>
          {page === '...' ? (
            <div className="w-10 h-10 flex items-center justify-center text-gray-400">
              <i className="ri-more-line text-xl"></i>
            </div>
          ) : (
            <button
              onClick={() => onPageChange(page as number)}
              className={`w-10 h-10 flex items-center justify-center rounded-lg font-semibold transition-all cursor-pointer ${
                currentPage === page
                  ? 'bg-[#D4AF37] text-white'
                  : 'border-2 border-gray-200 text-gray-600 hover:border-[#D4AF37] hover:text-[#D4AF37]'
              }`}
            >
              {page}
            </button>
          )}
        </div>
      ))}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="w-10 h-10 flex items-center justify-center rounded-lg border-2 border-gray-200 text-gray-600 hover:border-[#D4AF37] hover:text-[#D4AF37] disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer transition-all"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>
    </div>
  );
}
